<footer class="navbar fixed-bottom">
    <ul class="list-of-languages">
        <li style="line-height: 50px;" *ngFor="let language of listOfLanguages">
            <img class="language-img" (click)="changeLanguage($event, language)" [alt]="language.description" [title]="language.description" [src]="language.languageImage"/>
        </li>
    </ul>
    <p><span class="link-partteam" (click)="partteam()">Desenvolvido por PARTTEAM & OEMKIOSKS</span> | <span (click)="terms()" class="link-partteam">{{ 'TitleTermsFrontOffice' | translate }}</span></p>
</footer>
